"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.056 11.75h2.222c2.305 0 4.167 1.675 4.167 3.75s-1.862 3.75-4.167 3.75h-2.222v-7.5zm0-7h1.527c1.917 0 3.473 1.4 3.473 3.125S13.5 11 11.583 11h-1.527V4.75zM4.5 4v.75h1.667c.458 0 .833.338.833.75v13c0 .413-.375.75-.833.75h-1.39V20H14.5c2.764 0 5-2.012 5-4.5 0-1.875-1.28-3.489-3.099-4.164 1.194-.713 1.988-1.948 1.988-3.336 0-2.213-1.986-4-4.445-4H4.5z" }), "Bold");
//# sourceMappingURL=Bold.js.map